import React, { ReactNode, useEffect } from "react"
import Image from "next/image"

import { useUpdateableState } from "@lib"

const Accordion: React.FunctionComponent<{
    id?: string,
    expanded?: boolean
    title?: ReactNode,
    summary?: ReactNode,
    onExpand?: (id?: string) => void,
    onCollapse?: (id?: string) => void
}> = ({
    id,
    expanded,
    title,
    /** Summary is only shown when collapsed */
    summary,
    children,
    onExpand,
    onCollapse
}) => {
    const [isExpanded, setExpanded] = useUpdateableState<boolean>(expanded)

    useEffect(() => {
        if (isExpanded) {
            onExpand && onExpand(id)
        } else {
            onCollapse && onCollapse(id)
        }
    }, [isExpanded, onExpand, onCollapse, id])

    return (
        <div id={id}>
            <div className="px-[20px] py-[16px] bg-white-900 cursor-pointer">
                <div className={["flex"].concat(!isExpanded && summary ? ["mb-[20px]"] : []).join(" ")}
                    onClick={() => setExpanded(!isExpanded)}>
                    <div className="flex-1">
                        <div>{title}</div>
                    </div>

                    <button type="button" className={["w-[24px] h-[24px] transition duration-300", isExpanded ? "rotate-180" : "rotate-0"].join(" ")}>
                        <Image width={24} height={24} objectFit="contain" src="/images/ic_chevron_down_accent.svg" alt="Dropdown Icon" />
                    </button>
                </div>

                {!isExpanded && summary && <div>{summary}</div>}
            </div>

            {isExpanded &&
                <div className="bg-white-900">
                    {children}
                </div>
            }
        </div>
    )
}

export default Accordion